import { render, staticRenderFns } from "./PurchasesReservations.vue?vue&type=template&id=1c58ff76&"
import script from "./PurchasesReservations.vue?vue&type=script&lang=js&"
export * from "./PurchasesReservations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports